var CART_NOTIFIER_LOAD_SUCCESS = 'CART_NOTIFIER_LOAD_SUCCESS';
var CART_NOTIFIER_LOAD_URL = '/cart/notifier/load';
var REDUCER_CART_NOTIFIER_NAME = 'cartNotifier';
export { CART_NOTIFIER_LOAD_SUCCESS, CART_NOTIFIER_LOAD_URL, REDUCER_CART_NOTIFIER_NAME };